// Centralized API configuration
export const API_BASE_URL = process.env.REACT_APP_API_BASE || 'http://127.0.0.1:5001';

// Remove trailing slash if present
export const API_URL = API_BASE_URL.replace(/\/$/, '');

